import { inject, Injectable } from '@angular/core';

import { LangService } from '@reforgium/presentia';
import { SkToastAppearance, SkToastService } from '@ss/ui';

type NotificationSeverity = 'success' | 'info' | 'warn' | 'error';

const TOAST_APPEARANCE: Record<NotificationSeverity, SkToastAppearance> = {
  success: 'success',
  info: 'info',
  warn: 'warning',
  error: 'danger',
};

type NotificationOptions = {
  translate?: boolean;
  life?: number;
  summary?: string;
};

@Injectable({ providedIn: 'root' })
export class AppNotificationService {
  private readonly toast = inject(SkToastService);
  private readonly lang = inject(LangService);

  error(message: string, options?: NotificationOptions): Promise<void> {
    return this.show('error', message, options);
  }

  info(message: string, options?: NotificationOptions): Promise<void> {
    return this.show('info', message, options);
  }

  success(message: string, options?: NotificationOptions): Promise<void> {
    return this.show('success', message, options);
  }

  warn(message: string, options?: NotificationOptions): Promise<void> {
    return this.show('warn', message, options);
  }

  private async show(severity: NotificationSeverity, message: string, options?: NotificationOptions): Promise<void> {
    let detail = message;

    if (options?.translate) {
      try {
        await this.lang.loadNamespace(message.split('.')[0]);
        detail = this.lang.get(message);
      } catch {
        detail = message;
      }
    }

    this.toast.notify(detail, TOAST_APPEARANCE[severity], {
      summary: options?.summary,
      life: options?.life ?? 3000,
    });
  }
}
